import type { UserLog } from '#/domain/user/UserLog'
import type { UserRepository } from '#/domain/user/UserRepository'

export class GetUserLogsUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(userId: string, page?: number, perPage?: number): Promise<UserLog[]> {
    return this.repository.findLogs(userId, page, perPage)
  }
}
